import React from 'react';
import { motion } from 'framer-motion';
import { EXPERIENCE } from '../data/experience';
import { Briefcase } from 'lucide-react';

const Experience: React.FC = () => {
  return (
    <section className="screen-line-after px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-xl font-bold text-foreground mb-8 flex items-center gap-2">
          <Briefcase size={18} className="text-muted-foreground" />
          Experience
        </h2>

        <div className="space-y-6">
          {EXPERIENCE.map((job, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: idx * 0.1 }}
              className="relative py-4 screen-line-after last:border-b-0"
            >
              {/* Company Header */}
              <div className="mb-6">
                <h3 className="text-lg font-bold text-foreground">
                  {job.company}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {job.location}
                </p>
              </div>

              {/* Roles Timeline */}
              <div className="relative border-l border-border ml-2 space-y-8 pb-2">
                {job.roles.map((role, roleIdx) => (
                  <div key={roleIdx} className="relative pl-6">
                    {/* Timeline Dot */}
                    <div className="absolute -left-[5px] top-2 w-2.5 h-2.5 rounded-full bg-border" />

                    {/* Role Header */}
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-1 mb-2">
                      <h4 className="text-base font-semibold text-foreground">
                        {role.role}
                      </h4>
                      <span className="text-xs font-mono text-muted-foreground whitespace-nowrap mt-0.5">
                        {role.period}
                      </span>
                    </div>

                    {/* Tech stack */}
                    {'tech' in role && role.tech && (
                      <div className="flex flex-wrap gap-1.5 mb-3 mt-2">
                        {(role.tech as string).split(', ').map((t: string) => (
                          <span
                            key={t}
                            className="px-1.5 py-0.5 text-[10px] font-mono text-muted-foreground border border-border rounded"
                          >
                            {t}
                          </span>
                        ))}
                      </div>
                    )}

                    {/* Bullets */}
                    <ul className="space-y-2 mt-3">
                      {role.bullets.map((bullet, bIdx) => (
                        <li
                          key={bIdx}
                          className="text-sm text-muted-foreground leading-relaxed pl-4 relative before:content-['–'] before:absolute before:left-0 before:text-muted-foreground/50"
                        >
                          {bullet}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Experience;